var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "form icons-search position-relative",
      attrs: { id: "icons-search" },
    },
    [
      _c(
        "div",
        {
          staticClass: "with-icon-before",
          staticStyle: {
            "--input-with-icon-color": "var(--fa-navy)",
            "--input-border-color": "var(--fa-navy)",
          },
        },
        [
          _c("font-awesome-icon", {
            staticStyle: { "line-height": "1" },
            attrs: { icon: _vm.$v6.solid.faMagnifyingGlass },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "sr-only", attrs: { for: "icons-search" } },
            [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]
          ),
          _vm._v(" "),
          _c("input", {
            ref: "searchTerm",
            class: _vm.inputClass,
            attrs: {
              id: "icons-search",
              name: "icons-search",
              type: "text",
              placeholder: `Search ${_vm.$counts.icons.all.formatted} icons...`,
            },
            domProps: { value: _vm.term },
            on: {
              input: _vm.inputChanged,
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return ((event) =>
                  _vm.$emit("go", event.currentTarget.value)).apply(
                  null,
                  arguments
                )
              },
              focus: (event) => _vm.$emit("focus"),
              blur: (event) => _vm.$emit("blur"),
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isShowingClearButton
        ? _c("span", { staticClass: "icons-search-clear" }, [
            _c(
              "button",
              {
                staticClass: "link size-lg margin-0 padding-y-2xs padding-x-xs",
                staticStyle: {
                  "--button-color": "var(--fa-gravy)",
                  "--button-hover-color": "var(--fa-red)",
                  "--button-box-shadow-width": "0",
                },
                attrs: {
                  "aria-label": "Clear Current Search",
                  "data-balloon-pos": "up",
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return ((event) => _vm.$emit("clear")).apply(
                      null,
                      arguments
                    )
                  },
                },
              },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: _vm.$v6.solid.faCircleXmark },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowingGoButton
        ? _c("span", { staticClass: "icons-search-clear" }, [
            _c(
              "button",
              {
                staticClass: "link size-lg margin-0 padding-y-2xs padding-x-xs",
                staticStyle: {
                  "--button-color": "var(--fa-gravy)",
                  "--button-hover-color": "var(--fa-dk-blue)",
                  "--button-box-shadow-width": "0",
                },
                attrs: { "aria-label": "Search", "data-balloon-pos": "up" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return ((event) => _vm.$emit("go", _vm.term)).apply(
                      null,
                      arguments
                    )
                  },
                },
              },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: _vm.$v6.solid.faCircleArrowRight },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowingPoweredBy ? _c("powered-by-algolia") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }